module.exports = __webpack_public_path__ + "img/bg17@2x.9fc8883b.jpg";